import React from "react";
import PropTypes from "prop-types";

const CURRENCY_SYMBOL = {
    AED: "د.إ",
    AUD: "$",
    CAD: "$",
    DKK: "kr.",
    EUR: "€",
    GBP: "£",
    HKD: "$",
    ISK: "kr",
    JPY: "¥",
    KWD: "د.ك",
    NOK: "kr",
    OMR: "﷼",
    RUB: "₽",
    SAR: "ر.س",
    SEK: "kr",
    SGD: "S$",
    USD: "$"
};
// todo I18N-470
function Price({ value, currency }) {
    return (
        <span>
            {CURRENCY_SYMBOL[currency] ? CURRENCY_SYMBOL[currency] : CURRENCY_SYMBOL["USD"]}
            {value}
        </span>
    );
}

const pricePropTypes = {
    value: PropTypes.string.isRequired,
    currency: PropTypes.oneOf(Object.keys(CURRENCY_SYMBOL)).isRequired
};

Price.propTypes = pricePropTypes;

export { Price as default, pricePropTypes };
